// extracted by mini-css-extract-plugin
module.exports = {"employers__carousel":"styles_employers__carousel__xRb9r","employers__footer":"styles_employers__footer__ZAbJr","employers__link":"styles_employers__link__6WKGl"};